// extracted by mini-css-extract-plugin
export var cover_wrapper = "index-module--cover_wrapper--5053d";
export var inner = "index-module--inner--5c785";
export var title = "index-module--title--7ba60";
export var wrapper = "index-module--wrapper--1f36e";